export default __webpack_public_path__ + "static/media/doc-active.d7cd6f5f.svg";